import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export default function PwaBanner({ setBanner }) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    setShow(true);
  }, []);
  return (
    <div
      className={` flex items-center bg-[#fff] w-full px-[8px]  transition-all ease-in duration-500 
      ${show ? "opacity-1" : "opacity-0"}
      `}
    >
      <button
        className="px-[16px] py-[12px] my-[12px] text-[#ffffff] bg-[#58B000] rounded-[12px] text-small-medium whitespace-nowrap"
        onClick={() =>
          navigate("/install", {
            state: { previousLocation: window.location.pathname },
          })
        }
      >
        Install Goviral App
      </button>
      <p
        className="text-black text-regular-medium pl-[12px]"
        style={{ fontSize: "min(3vw, 13px)" }}
      >
        Get the Goviral App for new contests, offers & much more!
      </p>

      <div className=" py-[12px] pl-[12px]" onClick={() => setBanner(false)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          className="w-[20px] h-[20px]"
        >
          <path
            d="M9.7785 0.22908C9.70833 0.158765 9.62498 0.10298 9.53323 0.0649179C9.44147 0.0268556 9.34311 0.00726357 9.24377 0.00726357C9.14443 0.00726357 9.04607 0.0268556 8.95431 0.0649179C8.86255 0.10298 8.7792 0.158765 8.70903 0.22908L5 3.93053L1.29097 0.221495C1.22075 0.151273 1.13738 0.0955689 1.04563 0.0575646C0.95388 0.0195603 0.855543 7.39916e-10 0.756233 0C0.656923 -7.39917e-10 0.558585 0.0195603 0.466835 0.0575646C0.375085 0.0955689 0.291718 0.151273 0.221495 0.221495C0.151273 0.291718 0.0955689 0.375085 0.0575646 0.466835C0.0195603 0.558585 -7.39916e-10 0.656923 0 0.756233C7.39917e-10 0.855543 0.0195603 0.95388 0.0575646 1.04563C0.0955689 1.13738 0.151273 1.22075 0.221495 1.29097L3.93053 5L0.221495 8.70903C0.151273 8.77925 0.0955689 8.86262 0.0575646 8.95437C0.0195603 9.04612 0 9.14446 0 9.24377C0 9.34308 0.0195603 9.44141 0.0575646 9.53316C0.0955689 9.62492 0.151273 9.70828 0.221495 9.7785C0.291718 9.84873 0.375085 9.90443 0.466835 9.94244C0.558585 9.98044 0.656923 10 0.756233 10C0.855543 10 0.95388 9.98044 1.04563 9.94244C1.13738 9.90443 1.22075 9.84873 1.29097 9.7785L5 6.06947L8.70903 9.7785C8.77925 9.84873 8.86262 9.90443 8.95437 9.94244C9.04612 9.98044 9.14446 10 9.24377 10C9.34308 10 9.44141 9.98044 9.53316 9.94244C9.62492 9.90443 9.70828 9.84873 9.7785 9.7785C9.84873 9.70828 9.90443 9.62492 9.94244 9.53316C9.98044 9.44141 10 9.34308 10 9.24377C10 9.14446 9.98044 9.04612 9.94244 8.95437C9.90443 8.86262 9.84873 8.77925 9.7785 8.70903L6.06947 5L9.7785 1.29097C10.0667 1.00274 10.0667 0.517308 9.7785 0.22908Z"
            fill="black"
          />
        </svg>
      </div>
    </div>
  );
}
